<template>
  <div>
    <a-modal modal-id="add-account">
      <div slot="title">Add Account</div>
      <div slot="form">
        <div class="row">
          <label>Name</label>
          <input type="text" placeholder="Service name" class="form-control" v-model="accountData.name">
        </div>
        <div class="row m-t-sm">
          <label>URL</label>
          <input type="text" placeholder="Login URL" class="form-control" v-model="accountData.url">
        </div>
        <div class="row m-t-sm">
          <label>Description</label>
          <input type="text" placeholder="Service description" class="form-control" v-model="accountData.description">
        </div>
        <div class="row m-t-sm">
          <label>Departments</label>
          <v-select multiple :options="userDepartments" label="label" index="index" v-model="accountData.departments" placeholder="Departments that can see it"></v-select>
        </div>
        <div class="row m-t-sm">
          <label>Credentials</label>
          <div v-for="(cred, i) in credentials" :key="i + '-' + accountData.name" :class="'col-lg-12 ' + ((i === credentials.length - 1) ? 'green-left-border' : '')">
            <div class="row m-t-xs">
              <div class="col-lg-5">
                <input type="text" placeholder="email, username etc..." class="form-control" v-model="cred.prop" :ref="'propInput-' + i">
              </div>
              <div class="col-lg-5">
                <input type="text" placeholder="value" class="form-control" v-model="cred.val" @keydown.enter="addValue">
              </div>
              <div class="col-lg-2 buttons-container">
                <button v-if="credentials.length - 1 === i" class="btn btn-success btn-sm" v-tooltip="'Add new credential to the list'" @click="addValue">
                  <i class="fa fa-plus"></i>
                </button>
                <button class="btn btn-danger btn-sm" v-tooltip="'Remove credential from list'" @click="removeValue(i)">
                  <i class="fa fa-multiply"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-primary pull-right" @click="saveAccount"><i class="fa fa-save m-r-xs"></i>Save</button>
      </div>
    </a-modal>
    <a-modal modal-id="show-account-credentials">
      <div slot="title">{{ accountData.name }} Credentials</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12 m-b-sm">
            <div class="col-lg-3">
              <b>Url</b>
            </div>
            <div class="col-lg-9">
              <a :href="accountData.url" target="_blank">{{ accountData.url }} <i class="fa fa-external-link"></i></a>
            </div>
          </div>
          <div v-if="!isDecrypted" class="col-lg-12">
            <span class="col-lg-8">
              <strong>Credentials are encrypted</strong>
            </span>
            <button class="btn btn-success" @click="decryptCredentials(accountData.id)"><i class="fa fa-eye"></i> Show</button>
          </div>
          <div v-else-if="isDecrypting" class="loader"></div>
          <div v-else class="col-lg-12 m-t-xs" v-for="(cred, i) in Object.entries(accountData.credentials)" :key="i + '-' + accountData.name">
            <div class="col-lg-3">
              <strong>
                {{ cred[0] }}
                <i v-if="cred[0] === 'otp'" class="fa fa-circle-info green" v-tooltip="'This one time password will expire in 30 seconds'"></i>
              </strong>
            </div>
            <div class="col-lg-7">
              <span>{{ cred[1] }}</span>
              <button class="btn btn-primary pull-right btn-sm" v-tooltip="'Copy value'" @click="copyToClipboard(cred[1], true)"><i class="fa fa-copy"></i></button>
              <button v-if="cred[0] === 'otp'" class="btn btn-success btn-sm pull-right m-r-xs" v-tooltip="'Generate new OTP'" @click="generateNewOTP(accountData.id)"><i class="fa fa-refresh"></i></button>
            </div>
         </div>
        </div>
      </div>
    </a-modal>
    <in-wrapper>
      <in-ibox>
        <div slot="title">
          Service Accounts
          <button data-toggle="modal" data-target="#add-account" class="btn btn-xs btn-primary pull-right" @click="initAccountData"><i class="fa fa-plus m-r-xs"></i>New Account</button>
        </div>
        <div slot="content" class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-2">
                <label>URL</label>
                <input type="text" placeholder="URL" class="form-control" v-model="filters.url" @keydown.enter="getAccounts">
              </div>
              <div class="col-lg-2">
                <label>Name</label>
                <input type="text" placeholder="Name" class="form-control" v-model="filters.name" @keydown.enter="getAccounts">
              </div>
              <div class="col-lg-2">
                <label>Department</label>
                <v-select
                  multiple
                  placeholder="Departments"
                  label="label" index="index"
                  :options="departmentsOptions"
                  v-model="filters.departments"
                  @change="getAccounts"
                ></v-select>
              </div>
            </div>
            <table class="table table-striped table-hover m-t-sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Departments</th>
                  <th>URL</th>
                  <th>Added By</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="acc in accountsCred" :key="acc.id">
                  <td>
                    <router-link :to="{path: '/service-accounts/' + acc.id }">{{ acc.name }}</router-link>
                  </td>
                  <td>{{ acc.description || '/' }}</td>
                  <td>
                    <span v-for="(val, i) in acc.departments" :key="'depts' + acc.id + i" class="label label-primary m-r-xs">
                      {{ val }}
                    </span>
                  </td>
                  <td><a :href="acc.url.slice(0,4) === 'http' ? acc.url : 'https://' + acc.url" target="_blank">{{ acc.url }}</a></td>
                  <td>{{ acc.creator.username }}</td>
                  <td>
                    <button class="btn btn-primary btn-xs pull-right" v-tooltip="'Display credentials'" data-toggle="modal" data-target="#show-account-credentials" @click="accountData = {...acc}; isDecrypted = false"><i class="fa fa-eye"></i></button>
                  </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </in-ibox>
    </in-wrapper>
  </div>
</template>
<script>
import axios from 'axios'
import { Browser, Query, FormValidation } from '../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      accountsCred: [],
      accountData: {
        name: '',
        url: '',
        credentials: {}
      },
      credentials: [{
        prop: '',
        val: ''
      }],
      filters: {
        name: '',
        url: '',
        departments: null
      },
      userDepartments: [],
      departmentsOptions: [],
      isDecrypted: false,
      isDecrypting: false
    }
  },
  mixins: [Browser, Query, FormValidation],
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    this.getAccounts()
    this.getDepartments()
  },
  methods: {
    initAccountData () {
      this.accountData = {name: '', url: '', credentials: {}}
      this.credentials = [{prop: '', val: ''}]
    },
    async getAccounts () {
      try {
        let r = await axios.get('/v2/service-accounts?' + this.buildQuery(this.filters))
        this.accountsCred = r.data
      } catch (error) {
        this.$toastr.error('Failed to load account credentials', error)
      }
    },
    async getDepartments () {
      let r = await axios.get('/v2/data-structures?name=departments')
      this.departmentsOptions = r.data[0].values
      this.userDepartments = this.user.master ? this.departmentsOptions : this.departmentsOptions.filter(el => this.user.departments.includes(el.index))
    },
    async saveAccount () {
      if (!this.accountData.name.trim().length || !this.accountData.url.trim().length) {
        this.$toastr.warning('Name and URL are required fields')
        return
      }
      if (!this.isUrl(this.accountData.url)) {
        this.$toastr.warning('Please enter a valid URL')
        return
      }

      for (let i = 0; i < this.credentials.length; i++) {
        const { prop, val } = this.credentials[i]
        if (prop === 'email' && !this.isEmail(val)) {
          this.$toastr.warning('Invalid email format')
          return
        }
        if (prop.trim().length && val.trim().length) this.accountData.credentials[prop] = val
      }
      if (!Object.keys(this.accountData.credentials).length) {
        this.$toastr.warning('Credentials cannot be empty')
        return
      }

      try {
        await axios.post('/v2/service-accounts', this.accountData)
        await this.getAccounts()
        this.$toastr.success('Account credentials updated')
        $('#add-account').modal('hide')
        this.initAccountData()
      } catch (error) {
        this.$toastr.error('Failed to add account credentials', error)
      }
    },
    addValue () {
      const {prop, val} = this.credentials[this.credentials.length - 1]
      if (!prop.trim().length || !val.trim().length) {
        this.$toastr.warning('Please fill the current credential value before adding a new one!')
        return
      }
      if (this.credentials.slice(0, -1).map(el => el.prop).includes(prop)) {
        this.$toastr.warning('Please enter a different property', 'Same property cannot be entered twice')
        return
      }
      this.credentials.push({prop: '', val: ''})
      this.focusOnNextPropInput()
    },
    removeValue (i) {
      if (this.credentials.length === 1) {
        this.$toastr.warning('Cannot remove the only value in the list')
        return
      }
      this.credentials.splice(i, 1)
    },
    focusOnNextPropInput () {
      this.$nextTick(() => {
        let inputRef = 'propInput-' + (this.credentials.length - 1)
        this.$refs[inputRef][0].focus()
      })
    },
    async deleteAccountCred (account) {
      if (confirm(`Are you sure you want to delete ${account.name}?\nThe credentials will still work but will not be shown here anymore`)) {
        try {
          await axios.delete(`/v2/service-accounts/${account.id}`)
          await this.getAccounts()
          $('#add-account-cred').modal('hide')
          this.$toastr.success('Account credential removed')
        } catch (error) {
          this.$toastr.error('Failed to delete account credential', error)
        }
      }
    },
    async decryptCredentials (id) {
      try {
        let r = await axios.get(`/v2/service-accounts/${id}/decrypt`)
        this.accountData.credentials = r.data
        this.isDecrypted = true
      } catch (error) {
        this.$toastr.error('Decrypting failed', error)
      }
    },
    async generateNewOTP (id) {
      try {
        this.isDecrypted = false
        this.isDecrypting = true

        let r = await axios.post(`/v2/service-accounts/${id}/otp/generate`)
        this.$set(this.accountData.credentials, 'otp', r.data.otp)

        this.isDecrypting = false
        this.isDecrypted = true
      } catch (error) {
        this.$toastr.error('Failed to generate new OTP', error)
      }
    }
  }
}
</script>
<style scoped>
.green-left-border {
  border-left: 5px solid #18a689;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ServiceAccounts/ServiceAccounts.vue